<div *ngIf="modalVisible" class="ip-dialog" [@slideUp]="mobile ? 'in' : ''">
  <div class="ip-block-card-modal">
    <div *ngIf="showTitle" class="ip-block-card-modal__header">
      <div class="ip-block-card-modal__header-title">
        {{ titleCode ? (titleCode | translate) : title }}
      </div>
      <img
      *ngIf="showCloseModal"
      class="ip-block-card-modal__header-close"
      mat-dialog-close
      src="assets/icons/close-circle.svg"
      >
    </div>
    
    <div class="ip-block-card-modal__content" [style]="contentStyle">
      <ng-content></ng-content>
    </div>
  </div>
</div>
